import { render, staticRenderFns } from "./customer-profile-registration-dialog.vue?vue&type=template&id=0ac48cfa&scoped=true"
import script from "./customer-profile-registration-dialog.vue?vue&type=script&lang=js"
export * from "./customer-profile-registration-dialog.vue?vue&type=script&lang=js"
import style0 from "./customer-profile-registration-dialog.vue?vue&type=style&index=0&id=0ac48cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac48cfa",
  null
  
)

export default component.exports